import * as React from "react";
import LinearProgressWithLabel from "./LinearProgressWithLabel.js";
import Increment from "../functions/Increment.js";

function Technologies() {
  
  const html = Increment({  limite: 95, incremento: 10 });
  const js = Increment({  limite: 85, incremento: 10 });
  const php = Increment({  limite: 85, incremento: 10 });
  const net = Increment({  limite: 80, incremento: 10 });
  const phyton = Increment({  limite: 80, incremento: 10 });


  return (
    <>
      <LinearProgressWithLabel label="HTML / CSS" value={html} />

      <LinearProgressWithLabel label="JavaScript" value={js} />

      <LinearProgressWithLabel label="PHP" value={php} />

      <LinearProgressWithLabel label=".NET" value={net} />

      <LinearProgressWithLabel label="Python" value={phyton} />
    </>
  );
}

export default Technologies;
